import { Collapse } from "@mui/material";

import { useContext, useEffect, useState } from "react";

import { DOOR_TYPES } from "./DOOR_TYPES";

import { ApiContext } from "../ApiContext";

import { useTranslation } from "react-i18next";

import { TextFieldInput } from "../Common/TextFieldInput";
import { TextFieldSelect } from "../Common/TextFieldSelect";

import { ReactComponent as DoorNameIcon } from "../../Assets/Icons/DoorIcon_custom_stroke.svg";
import { ColorScheme } from "../../Themes/ColorScheme";
import { AlertBar } from "../Common/AlertBar";
import BigButton from "../Common/BigButton";
import OpeningHourDialog from "./OpeningHourDialog";

export const ModifyDoor = ({ content, handleDrawerClose }) => {
	const debug = false;

	const { ApiCall } = useContext(ApiContext);
	const { t } = useTranslation();

	const doorTypes = DOOR_TYPES();

	const [doorName, setDoorName] = useState(content?.name || "");
	const [selectedType, setSelectedType] = useState(content?.type || "door");
	const [showLoader, setShowLoader] = useState(false);
	const [error, setError] = useState("");
	const [dialogOpen, setDialogOpen] = useState(false);

	const handleSave = () => {
		setShowLoader(true);

        ApiCall("PUT", "client/door/" + content.id, {
            name: doorName,
            type: String(selectedType),
        })
            .then(() => {
                setShowLoader(false);
                handleDrawerClose();
            }).catch((error) => {
                setError(error);
                setShowLoader(false);
                if (debug) console.log(error);
            });
	};

	const handleSelectChange = (value) => {
		setSelectedType(value);
	};

    useEffect(() => {
        if (doorName.length > 0) {
			setError("");
		} else {
			setError(t("doors.door_name_cannot_be_empty"));
		}
    }, [doorName]);

	useEffect(() => {
		console.log(dialogOpen);
	}, [dialogOpen]);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between",
				gap: "20px"
			}}
		>
			<TextFieldInput
				title={t("doors.door_name")}
				fullWidth
				checkValue={error === t("doors.door_name_cannot_be_empty")}
				text={doorName}
				valueChange={setDoorName}
				hasProps={
					<DoorNameIcon stroke={ColorScheme.darkGrey} />
				}
			/>

			<div
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "stretch",
					width: "100%",
					gap: "20px",
					boxSizing: "border-box"
				}}
			>
				<div style={{ width: "100%" }}>
					<TextFieldSelect
						label={t("doors.door_types")}
						selected={selectedType}
						valueChange={handleSelectChange}
						options={doorTypes}
						hasProps={
							<DoorNameIcon
								stroke={ColorScheme.darkGrey}
							/>
						}
					/>
				</div>
			</div>

			<div
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "stretch",
					width: "100%",
					gap: "20px",
					boxSizing: "border-box"
				}}
			>
				<div style={{ width: "100%" }}>
					<BigButton 
						text={t("doors.modify_opening_hours")}
						action={() => {
							console.log("Opening hours");
							setDialogOpen(true)
						}}
						backgroundColor={ColorScheme.secondary}
						textColor={ColorScheme.buttonSecondaryText}
						borderColor={ColorScheme.buttonPrimary}
						width={"100%"}
					/>
				</div>
			</div>

			<Collapse in={error.length > 0} collapsedSize={0}>
				<AlertBar
					type={"error"}
					standardVariant={true}
					textContent={error}
					showAlert={true}
				/>
			</Collapse>

			<div style={{ flex: 1 }} />

			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					paddingBottom: "20px"
				}}
			>
				<BigButton 
					text={t("buttons.cancel")}
					action={() => handleDrawerClose()}
					backgroundColor={ColorScheme.buttonSecondary}
					textColor={ColorScheme.buttonSecondaryText}
					borderColor={ColorScheme.buttonPrimary}
					width={"47%"}
				/>
				<BigButton
					text={t("buttons.save")}
					action={() => handleSave()}
					backgroundColor={ColorScheme.buttonPrimary}
					textColor={ColorScheme.secondary}
					borderColor={ColorScheme.buttonPrimary}
					width={"47%"}
					activity={showLoader}
				/>
			</div>
			<OpeningHourDialog 
				dialogOpen={dialogOpen} 
				closeDialog={() => {
					console.log("Closing dialog");
					setDialogOpen(false)
				}}
				door={content} />
		</div>
	);
};
